// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMyBookingResponse

import { BookingStatus, GuaranteeStatus, GuaranteeType } from './enums.gen';
import { hydrateWidgetBookingCustomer, type WidgetBookingCustomer, type WidgetBookingCustomerApiResponse } from './widgetBookingCustomer.gen';
import { hydrateWidgetMyBookingSession, type WidgetMyBookingSession, type WidgetMyBookingSessionApiResponse } from './widgetMyBookingSession.gen';
import { hydrateWidgetMyBookingProduct, type WidgetMyBookingProduct, type WidgetMyBookingProductApiResponse } from './widgetMyBookingProduct.gen';
import { hydrateWidgetMyBookingOffer, type WidgetMyBookingOffer, type WidgetMyBookingOfferApiResponse } from './widgetMyBookingOffer.gen';
import { hydrateWidgetBookingPaymentItem, type WidgetBookingPaymentItem, type WidgetBookingPaymentItemApiResponse } from './widgetBookingPaymentItem.gen';
import { hydrateWidgetBookingPriceSummary, type WidgetBookingPriceSummary, type WidgetBookingPriceSummaryApiResponse } from './widgetBookingPriceSummary.gen';
import { hydrateWidgetMyBookingContact, type WidgetMyBookingContact, type WidgetMyBookingContactApiResponse } from './widgetMyBookingContact.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetMyBookingApiResponse = {
	id: string;
	pax: number;
	date: string;
	note: string | null;
	customer: WidgetBookingCustomerApiResponse;
	status: BookingStatus;
	sessions: WidgetMyBookingSessionApiResponse[];
	customFields: Record<string, string>;
	products: WidgetMyBookingProductApiResponse[];
	offers: WidgetMyBookingOfferApiResponse[];
	payments: WidgetBookingPaymentItemApiResponse[];
	guaranteeAmount: number;
	areaPostBookingInfo: string;
	pricesSummary: WidgetBookingPriceSummaryApiResponse | null;
	cancellationTimeBefore: number | null;
	address: string | null;
	extraAddress: string | null;
	conferenceUrl: string | null;
	contact: WidgetMyBookingContactApiResponse | null;
	guaranteeStatus: GuaranteeStatus | null;
	guaranteeType: GuaranteeType | null;
	splitPaymentDeadline: string | null;
};

export type WidgetMyBooking = {
	id: string;
	pax: number;
	date: DateTime;
	note: string | null;
	customer: WidgetBookingCustomer;
	status: BookingStatus;
	sessions: WidgetMyBookingSession[];
	customFields: Record<string, string>;
	products: WidgetMyBookingProduct[];
	offers: WidgetMyBookingOffer[];
	payments: WidgetBookingPaymentItem[];
	guaranteeAmount: number;
	areaPostBookingInfo: string;
	pricesSummary: WidgetBookingPriceSummary | null;
	cancellationTimeBefore: number | null;
	address: string | null;
	extraAddress: string | null;
	conferenceUrl: string | null;
	contact: WidgetMyBookingContact | null;
	guaranteeStatus: GuaranteeStatus | null;
	guaranteeType: GuaranteeType | null;
	splitPaymentDeadline: DateTime | null;
};

export function hydrateWidgetMyBooking(data: WidgetMyBookingApiResponse): WidgetMyBooking {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		customer: hydrateWidgetBookingCustomer(data.customer),
		sessions: data.sessions.map(hydrateWidgetMyBookingSession),
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
		products: data.products.map(hydrateWidgetMyBookingProduct),
		offers: data.offers.map(hydrateWidgetMyBookingOffer),
		payments: data.payments.map(hydrateWidgetBookingPaymentItem),
		pricesSummary: data.pricesSummary ? hydrateWidgetBookingPriceSummary(data.pricesSummary) : null,
		contact: data.contact ? hydrateWidgetMyBookingContact(data.contact) : null,
		splitPaymentDeadline: DateTimefromISO(data.splitPaymentDeadline),
	};
}